import { Component, OnInit } from '@angular/core';
import { IntegratedAdmissionExtraordinaryWizardService } from '../service/integrated-admission-extraordinary.wizard.service';
import { IntegratedAdmissionWizardService } from '../service/integrated-admission-wizard.service';
import { InvoiceCashDeskService } from 'src/app/services/invoice-cash-desk/invoice-cash-desk.service';
import { InvoiceIntegratedAdmissionCashDeskService } from 'src/app/services/invoice-cash-desk/invoice-integrated-admission-cash-desk.service';
import { MenuService } from 'src/app/services/menu.service';

@Component({
  selector: 'app-integrated-extraordinary-admission-wizard',
  providers: [
    {
      provide: IntegratedAdmissionWizardService,
      useClass: IntegratedAdmissionExtraordinaryWizardService,
    },
    {
      provide: InvoiceCashDeskService,
      useClass: InvoiceIntegratedAdmissionCashDeskService,
    },
  ],
  templateUrl: './integrated-extraordinary-admission-wizard.component.html',
  styleUrls: ['./integrated-extraordinary-admission-wizard.component.css']
})
export class IntegratedExtraordinaryAdmissionWizardComponent implements OnInit {

  constructor(private menuService: MenuService) {
    this.menuService.setMenuTitle("Recepción", "extraordinaria integrada");
   }

  ngOnInit() {
  }

}
